import React from 'react';
import S from '../../UmbracoForm.styles';
const CheckBoxList = React.forwardRef(({ field, error, ...otherProps }, ref) => {
    return (React.createElement(S.Field, { className: error?.message && 'invalid' },
        React.createElement(S.Label, { as: "span" },
            field.caption,
            field.required && React.createElement(React.Fragment, null, "*")),
        React.createElement(S.List, null, field.values?.map((value, index) => (React.createElement(S.ControlLabel, { key: `option-${index}`, htmlFor: `${field.alias}-${index}` },
            React.createElement("input", { ref: ref, id: `${field.alias}-${index}`, type: "checkbox", required: field.required, value: value.value, ...otherProps }),
            React.createElement(S.CheckboxLabel, { dangerouslySetInnerHTML: {
                    __html: value.caption.replaceAll(/\*([^*]+?)\*/g, '<strong>$1</strong>'),
                } }))))),
        error && React.createElement(S.Error, null, error.message)));
});
CheckBoxList.displayName = 'CheckBoxList';
export default CheckBoxList;
